import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { LinksInterface } from '~/types/AppData/Layout/LinksInterface';
import More from '~/icons/more';

export default component$(({ menu }: { menu: LinksInterface }): JSX.Element => {
  // Use style so that we can unset inset and THEN control positioning - the order is very important with popovers
  const style = {
    inset: 'unset',
    top: '77px',
    left: '50%',
    transform: 'translateX(-50%)',
  };

  return (
    <div>
      <button class='flex' popovertarget='megamenu'>
        <More cssClasses='fill-white stroke-white' />
      </button>
      <div
        id='megamenu'
        style={style}
        class='p-6 shadow-megamenu w-max'
        popover='auto'
      >
        <div class='flex gap-6'>
          {menu.value.map((each, index) => {
            return (
              <div class='flex' key={index}>
                <div>
                  <strong class='flex w-[150px] font-group-tiny !font-bold mb-1'>
                    {each.link.text}
                  </strong>
                  <ul class='flex flex-wrap flex-col gap-1 max-h-[246px]'>
                    {each.children?.map((item, itemIndex) => {
                      return (
                        <li class='w-[150px] leading-[19px]' key={itemIndex}>
                          <a
                            class='font-group-tiny leading-[19px] hover:text-primary'
                            href={item.link.url}
                          >
                            {item.link.text}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                {index < menu.value.length - 1 && (
                  <div class='w-[1px] bg-grey h-full' />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});
